import React, { PureComponent } from 'react';

import LoadingButton from '../../utils/LoadingButton';
import { Grid } from '@mui/material';

import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import { saveCurrentMissionRecoveryZip } from '../../../dataModelHelpers';
import { alertInfo } from '../../../alertDispatcher';

interface DownloadRecoveryButtonProps {}

export default class DownloadRecoveryButton extends PureComponent<DownloadRecoveryButtonProps> {
  render() {
    return (
      <Grid>
        <LoadingButton
          variant="outlined"
          onClick={async () => {
            alertInfo('Starting manual download process');
            await saveCurrentMissionRecoveryZip({ tag: 'dl' });
            alertInfo('End manual download process');
          }}
          data-testid="mission-download-recovery"
        >
          <CloudDownloadIcon style={{ paddingRight: 7.5 }} />
          Recovery
        </LoadingButton>
      </Grid>
    );
  }
}
